import React, { useState } from "react";
import { priceTiers } from "../../data/megapack";
import { CTAButton } from "../CTAButton";
import { E } from "../Emoji";
export function PricingSection() {
  const [selected, setSelected] = useState<"standard" | "pro">("pro");
  const tiers = [priceTiers.standard, priceTiers.pro];
  const active = priceTiers[selected];
  return <section id="elegi" aria-labelledby="elegi-title" className="scroll-mt-4 bg-night" data-id="element-206" data-mp="281b1x019cak4">
      <div className="mx-auto max-w-2xl px-5 py-14" data-id="element-207" data-mp="2433ks42vt78e">
        <h2 id="elegi-title" className="text-center text-3xl font-black text-white" data-id="element-208" data-mp="1z262zslsaf7f">
          ELEGÍ TU <span className="text-bright" data-id="element-209" data-mp="1u32x65xzc4ye">MEGAPACK</span>
        </h2>
        <div role="radiogroup" aria-label="Elegí tu versión" className="mt-7 space-y-3" data-id="element-210" data-mp="1u5p72c8cewjs">
          {tiers.map(t => {
          const isOn = selected === t.id;
          return <button key={t.id} type="button" role="radio" aria-checked={isOn} onClick={() => setSelected(t.id)} className={`flex w-full items-center gap-3 rounded-2xl border-2 p-4 text-left transition-[border-color,background-color] duration-150 ease-out focus:outline-none focus-visible:ring-4 focus-visible:ring-sky/40 ${isOn ? "border-bright bg-navy shadow-[0_0_24px_rgba(77,148,255,0.3)]" : "border-line/40 bg-abyss hover:border-line"}`} data-id="element-211" data-mp="3ogudfoatdn2t">
                <span className={`flex h-5 w-5 shrink-0 items-center justify-center rounded-full border-2 ${isOn ? "border-bright" : "border-mute"}`} aria-hidden="true" data-id="element-212" data-mp="xtffsij2b4rx">
                  {isOn && <span className="h-2.5 w-2.5 rounded-full bg-bright" data-id="element-213" data-mp="o1stnr56rlae" />}
                </span>
                <div className="min-w-0 flex-1" data-id="element-214" data-mp="1brdgil4gn2oy">
                  <p className="text-lg" data-id="element-215" data-mp="1gkga2t98mc55"><E data-id="element-216" data-mp="1gkydc9ubhqmk">{t.emoji}</E></p>
                  <p className="font-black uppercase leading-tight text-white" data-id="element-217" data-mp="1gm18wv2l4h8t">
                    <E data-id="element-218" data-mp="1qfdpn3eu9hud">{t.title}</E>
                  </p>
                  <p className="text-sm text-white/75" data-id="element-219" data-mp="1lgu597fw8e44">{t.subtitle}</p>
                  <p className="mt-1 text-xs font-bold text-sky" data-id="element-220" data-mp="1hfh0l0ojegys">{t.idealFor}</p>
                </div>
                <div className="shrink-0 text-right" data-id="element-221" data-mp="1cgnuhtbkxs8n">
                  {t.referencePrice && <p className="text-xs text-mute line-through" data-id="element-222" data-mp="1cii8soscim3r">{t.referencePrice}</p>}
                  <p className="whitespace-nowrap text-xl font-black text-white md:text-2xl" data-id="element-223" data-mp="17im1ogocqejz">{t.price}</p>
                </div>
              </button>;
        })}
        </div>
        <p className="mt-3 text-center text-xs text-mute" data-id="element-224" data-mp="xs132t8oha12">El precio PRO es el total del paquete, no un adicional.</p>
        <div className="mt-5" data-id="element-225" data-mp="tnteqx64tw3d">
          <CTAButton href={active.href} checkout={{
          value: active.value,
          contentName: active.title,
          contentId: active.id
        }} data-id="element-226" data-mp="oqjr9n2azui6">
            {active.cta}
          </CTAButton>
        </div>
      </div>
    </section>;
}